export function buildHash(
  filters: Record<string, string[] | number[]>,
): string {
  return Object.entries(filters)
    .sort(([a], [b]) => a.localeCompare(b))
    .flatMap(([key, values]) =>
      (Array.isArray(values) ? values : [values]).map(
        (value) => `${key}=${value}`,
      ),
    )
    .join('&')
}
